<div class="ocr-suggestions">
    <div
        class="ocr-suggestions__header"
        (click)="toggleExpanded()">
        <i class="pi pi-sparkles"></i>
        <span>
            AI Document Suggestions
            @if (!suggestionsLoading && queriedAt != null) {
                <span class="ocr-suggestion-row__field">(Suggestions generated on {{ getSuggestionDate() }})</span>
            }
        </span>
        @if (suggestionsLoading) {
            <span class="ocr-suggestions__header-spinner"></span>
        } @else {
            <span (click)="$event.stopPropagation()">
                <i
                    class="pi pi-refresh"
                    (click)="refreshSuggestions(); $event.stopPropagation()"></i>
            </span>
            <i
                class="pi ocr-suggestions__chevron"
                [class.pi-chevron-down]="suggestionsExpanded"
                [class.pi-chevron-up]="!suggestionsExpanded"></i>
        }
    </div>
    @if (suggestionsExpanded) {
        @if (suggestionsLoading) {
            <div class="ocr-suggestions__loading">
                <app-embark-spinner
                    [size]="'2'"
                    [strokeWidth]="'5'"></app-embark-spinner>
                <span>Analyzing document…</span>
            </div>
        }
        @if (!suggestionsLoading && suggestions.length === 0) {
            <p class="ocr-suggestions__empty">No discrepancies found between the document and invoice.</p>
        }
        @if (!suggestionsLoading && suggestions.length > 0) {
            <div class="ocr-suggestions__list">
                @for (suggestion of suggestions; track suggestion[0]) {
                    @let isOutbound = isOutboundOnly(suggestion[0]);
                    @if (!isOutbound || canSubmit()) {
                        <div class="ocr-suggestion-row">
                            <div class="ocr-suggestion-row__checkbox">
                                <p-checkbox
                                    [binary]="true"
                                    [ngModel]="selectedFields[suggestion[0]] ?? false"
                                    (onChange)="toggleField(suggestion[0], $event.checked)" />
                            </div>
                            <div class="ocr-suggestion-row__field">{{ getFieldLabel(suggestion[0]) }}</div>
                            <div class="ocr-suggestion-row__values">
                                @if (currentValues()) {
                                    @let currentVal = getInvoiceFieldValue(suggestion[0]);
                                    @if (["—", "", " "].includes(currentVal)) {
                                        <span class="current-value current-value--empty">empty</span>
                                    } @else {
                                        <span class="current-value">{{ currentVal }}</span>
                                    }
                                    <i class="pi pi-arrow-right ocr-suggestion-row__arrow"></i>
                                }
                                <input
                                    pInputText
                                    class="proposed-input"
                                    type="text"
                                    [(ngModel)]="editedValues[suggestion[0]]"
                                    placeholder="empty" />
                            </div>
                            <div class="ocr-suggestion-row__confidence">
                                <ng-container
                                    [ngTemplateOutlet]="confidenceRing"
                                    [ngTemplateOutletContext]="{ $implicit: suggestion[1].confidence }" />
                            </div>
                        </div>
                    }
                }
            </div>
            @if (hasSelections && submitFn()) {
                <div class="ocr-suggestions__actions">
                    @if (submitting) {
                        <app-embark-spinner
                            [size]="'2'"
                            [strokeWidth]="'5'"></app-embark-spinner>
                    } @else {
                        <p-button
                            [style]="{
                                '--p-button-primary-background': '#f0ebe4',
                                '--p-button-primary-hover-background': '#e5ddd5',
                                '--p-button-primary-active-background': '#d9d0c7',
                                '--p-button-primary-border-color': '#f0ebe4',
                                '--p-button-primary-hover-border-color': '#e5ddd5',
                                '--p-button-primary-active-border-color': '#d9d0c7',
                                '--p-button-primary-color': '#7a6a5a',
                                '--p-button-primary-hover-color': '#7a6a5a',
                                '--p-button-primary-active-color': '#7a6a5a'
                            }"
                            (onClick)="clearChanges()"
                            label="Cancel" />
                        <p-button
                            [style]="{
                                '--p-button-primary-background': '#d97757',
                                '--p-button-primary-hover-background': '#c4663f',
                                '--p-button-primary-active-background': '#b05a34',
                                '--p-button-primary-border-color': '#d97757',
                                '--p-button-primary-hover-border-color': '#c4663f',
                                '--p-button-primary-active-border-color': '#b05a34',
                                '--p-button-primary-color': '#fff',
                                '--p-button-primary-hover-color': '#fff',
                                '--p-button-primary-active-color': '#fff'
                            }"
                            (onClick)="submitChanges()"
                            [label]="canSubmit() ? buttonText() : updateOnlyButtonText()" />
                    }
                </div>
            }
        }
    }
</div>

<ng-template
    #confidenceRing
    let-confidence>
    <svg
        width="44"
        height="44"
        viewBox="0 0 44 44">
        <circle
            cx="22"
            cy="22"
            r="18"
            fill="none"
            stroke="#e8e0d8"
            stroke-width="4" />
        <circle
            cx="22"
            cy="22"
            r="18"
            fill="none"
            [attr.stroke]="confidenceColor(confidence)"
            stroke-width="4"
            stroke-linecap="round"
            [attr.stroke-dasharray]="2 * 3.14159 * 18"
            [attr.stroke-dashoffset]="confidenceOffset(confidence)"
            transform="rotate(-90 22 22)" />
        <text
            x="22"
            y="27"
            text-anchor="middle"
            font-size="10"
            fill="#4a3728"
            font-family="sans-serif">
            {{ confidence * 100 | number: "1.0-0" }}%
        </text>
    </svg>
</ng-template>
